import { render, staticRenderFns } from "./ProposalRequestStatusHistory.vue?vue&type=template&id=61a5da23&scoped=true"
import script from "./ProposalRequestStatusHistory.vue?vue&type=script&lang=js"
export * from "./ProposalRequestStatusHistory.vue?vue&type=script&lang=js"
import style0 from "./ProposalRequestStatusHistory.vue?vue&type=style&index=0&id=61a5da23&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5da23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a5da23')) {
      api.createRecord('61a5da23', component.options)
    } else {
      api.reload('61a5da23', component.options)
    }
    module.hot.accept("./ProposalRequestStatusHistory.vue?vue&type=template&id=61a5da23&scoped=true", function () {
      api.rerender('61a5da23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/ProposalRequestStatusHistory.vue"
export default component.exports